export default __webpack_public_path__ + "static/media/portadavideoforecast2nuevo.31806a86.png";